import SupremeGolfApiClient from './SupremeGolfApiClient';

const REQUEST_RESET_PASSWORD_ENDPOINT = 'v6/users/password-reset';

class RequestResetPasswordApi {
  static async requestResetPassword(email, gRecaptchaResponseData) {
    const payload = { email };
    if (gRecaptchaResponseData) payload.gRecaptchaResponseData = gRecaptchaResponseData;
    const response = await SupremeGolfApiClient.post(REQUEST_RESET_PASSWORD_ENDPOINT, payload);
    const { data } = response;
    return data;
  }
}

export default RequestResetPasswordApi;
